import { gql } from '@apollo/client';

const CREATE_TEACHING_ORDER_CHANGED_EVENT = gql`
  mutation createTeachingOrderChangedEvent($data: TeachingOrderChangedEventCreateInput!) {
    createTeachingOrderChangedEvent(data: $data)
  }
`;

export default CREATE_TEACHING_ORDER_CHANGED_EVENT;
